import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "min-w-0 w-full" },
    [
      _c("div", { staticClass: "display-1" }, [
        _vm._v(_vm._s(_vm.$t("my_pendings.ownership_title"))),
      ]),
      _vm._t("default"),
      _c(
        "actions-component",
        { attrs: { class_table: _vm.getClassTable } },
        [
          _c(
            "template",
            { slot: "description" },
            [
              _c(VBreadcrumbs, {
                staticClass: "pa-0",
                attrs: { items: _vm.getBreadcrumbs },
              }),
            ],
            1
          ),
          _c(
            "template",
            { slot: "actions" },
            [
              _c(
                VBtn,
                {
                  staticClass: "ml-1 btn-inca-secondary",
                  attrs: { dense: "", outlined: "" },
                  on: { click: _vm.onEnableFilter },
                },
                [
                  _vm.filter_enabled
                    ? _c(VIcon, { attrs: { small: "" } }, [
                        _vm._v("mdi-filter-off-outline"),
                      ])
                    : _vm._e(),
                  !_vm.filter_enabled
                    ? _c(VIcon, { attrs: { small: "" } }, [
                        _vm._v("mdi-filter-outline"),
                      ])
                    : _vm._e(),
                  _vm._v(_vm._s(_vm.$t("btns.filter"))),
                ],
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
      _vm.filter_enabled
        ? _c(
            VCard,
            { staticClass: "d-block d-md-none mb-2" },
            [
              _c(VCardTitle, { staticClass: "pointer" }, [
                _vm._v(_vm._s(_vm.$t("my_pendings.search_filters"))),
              ]),
              _c(
                VCardText,
                { staticClass: "pa-2" },
                [
                  _c(VRow, { attrs: { dense: "" } }, [
                    _c(
                      "div",
                      { staticClass: "col-md-3" },
                      [
                        _c(VSelect, {
                          attrs: {
                            label: _vm.$t("my_pendings.object_type"),
                            outlined: "",
                            dense: "",
                            items: _vm.object_types,
                          },
                          on: { change: _vm.onChangeType },
                          model: {
                            value: _vm.typeSelected,
                            callback: function ($$v) {
                              _vm.typeSelected = $$v
                            },
                            expression: "typeSelected",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-md-3" },
                      [
                        _c(VTextField, {
                          attrs: {
                            label: _vm.$t("my_pendings.text_filter"),
                            placeholder: _vm.$t("my_pendings.text_filter"),
                            type: "text",
                            outlined: "",
                            dense: "",
                          },
                          on: {
                            keyup: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.onSearch($event)
                            },
                          },
                          model: {
                            value: _vm.text_filter,
                            callback: function ($$v) {
                              _vm.text_filter = $$v
                            },
                            expression: "text_filter",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-md-3 text-right" },
                      [
                        _c(
                          VBtn,
                          {
                            staticClass: "default mr-1",
                            attrs: { outlined: "" },
                            on: { click: _vm.onLimpiar },
                          },
                          [_vm._v(_vm._s(_vm.$t("btns.clean")))]
                        ),
                        _c(
                          VBtn,
                          {
                            staticClass: "primary",
                            on: { click: _vm.onSearch },
                          },
                          [_vm._v(_vm._s(_vm.$t("btns.search")))]
                        ),
                      ],
                      1
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c(VRow, [
        _c(
          "div",
          { class: _vm.getClassTable },
          [
            _vm.typeSelected == 1
              ? [
                  _vm.queryResponse &&
                  _vm.queryResponse.list_approval.length == 0
                    ? _c("StateComponent", {
                        attrs: {
                          state: "empty_state",
                          title: _vm.$t("my_pendings.no_ownership"),
                          subtitle: _vm.$t("my_pendings.no_ownership_subtitle"),
                        },
                      })
                    : _c(
                        VCard,
                        [
                          _vm.typeSelected == 1
                            ? _c(VDataTable, {
                                staticClass: "table-inca",
                                style: { "font-size": "11px" },
                                attrs: {
                                  responsive: "",
                                  hover: "",
                                  items: _vm.queryResponse.list_approval,
                                  headers: _vm.tableFields,
                                  search: _vm.filter.text_filter,
                                  filter_included_fields: _vm.filterOn,
                                  "sticky-header": true,
                                  page: _vm.pagination.current,
                                  "items-per-page": _vm.pagination.limit,
                                  "hide-default-footer": true,
                                },
                                on: {
                                  "update:page": function ($event) {
                                    return _vm.$set(
                                      _vm.pagination,
                                      "current",
                                      $event
                                    )
                                  },
                                  pagination: function ($event) {
                                    _vm.pagination.total = $event.itemsLength
                                  },
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "item.tablereference.tableid",
                                      fn: function (ref) {
                                        var item = ref.item
                                        return [
                                          _c(
                                            "div",
                                            { staticClass: "text-left" },
                                            [
                                              _c(
                                                "b",
                                                { staticClass: "table-name" },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      item.tableReference
                                                        .tableId
                                                    )
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "a",
                                                {
                                                  staticClass: "compose-name",
                                                  attrs: { title: item.id },
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm._f(
                                                        "joinTableReference"
                                                      )(item.tableReference)
                                                    )
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      },
                                    },
                                    {
                                      key: "item.lastmodifiedtime",
                                      fn: function (ref) {
                                        var item = ref.item
                                        return [
                                          _c("a", [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("formatDate")(
                                                  item.lastModifiedTime
                                                )
                                              )
                                            ),
                                          ]),
                                        ]
                                      },
                                    },
                                    {
                                      key: "item.actions",
                                      fn: function (ref) {
                                        var item = ref.item
                                        return [
                                          _c(
                                            VBtn,
                                            {
                                              attrs: {
                                                rounded: "",
                                                small: "",
                                                dense: "",
                                                outlined: "",
                                                size: "sm",
                                                color: "secondary",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.openAcceptOwner(
                                                    item
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("btns.accept_reject")
                                                )
                                              ),
                                            ]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  3448707284
                                ),
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                ]
              : _vm._e(),
            _vm.typeSelected == 2
              ? [
                  _vm.lst_datasource.length == 0
                    ? _c("StateComponent", {
                        attrs: {
                          state: "empty_state",
                          title: _vm.$t("my_pendings.no_ownership"),
                          subtitle: _vm.$t("my_pendings.no_ownership_subtitle"),
                        },
                      })
                    : _c(
                        VCard,
                        [
                          _vm.typeSelected == 2
                            ? _c(VDataTable, {
                                staticClass: "table-inca",
                                style: { "font-size": "11px" },
                                attrs: {
                                  responsive: "",
                                  hover: "",
                                  items: _vm.lst_datasource,
                                  headers: _vm.tableauFields,
                                  search: _vm.filter.text_filter,
                                  filter_included_fields: _vm.filterOn,
                                  "sticky-header": true,
                                  page: _vm.pagination.current,
                                  "items-per-page": _vm.pagination.limit,
                                  "hide-default-footer": true,
                                },
                                on: {
                                  "update:page": function ($event) {
                                    return _vm.$set(
                                      _vm.pagination,
                                      "current",
                                      $event
                                    )
                                  },
                                  pagination: function ($event) {
                                    _vm.pagination.total = $event.itemsLength
                                  },
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "item.objectReference.object_name",
                                      fn: function (ref) {
                                        var item = ref.item
                                        return [
                                          _c(
                                            "div",
                                            { staticClass: "text-left" },
                                            [
                                              _c(
                                                "b",
                                                { staticClass: "table-name" },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      item.objectReference
                                                        .object_name
                                                    )
                                                  ),
                                                ]
                                              ),
                                              _c("br"),
                                              _c(
                                                "a",
                                                {
                                                  staticClass: "compose-name",
                                                  attrs: { title: item.id },
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      item.objectReference
                                                        .path_name
                                                    ) +
                                                      ":" +
                                                      _vm._s(
                                                        item.objectReference
                                                          .object_name
                                                      )
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      },
                                    },
                                    {
                                      key: "item.lastmodifiedtime",
                                      fn: function (ref) {
                                        var item = ref.item
                                        return [
                                          _c("a", [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("formatDate")(
                                                  item.lastModifiedTime
                                                )
                                              )
                                            ),
                                          ]),
                                        ]
                                      },
                                    },
                                    {
                                      key: "item.actions",
                                      fn: function (ref) {
                                        var item = ref.item
                                        return [
                                          _c(
                                            VBtn,
                                            {
                                              attrs: {
                                                rounded: "",
                                                small: "",
                                                dense: "",
                                                outlined: "",
                                                size: "sm",
                                                color: "secondary",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.onTableauDataSourceOwner(
                                                    item
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("btns.accept_reject")
                                                )
                                              ),
                                            ]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  385494120
                                ),
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                ]
              : _vm._e(),
            _vm.typeSelected == 3
              ? [
                  _vm.lst_workbook.length == 0
                    ? _c("StateComponent", {
                        attrs: {
                          state: "empty_state",
                          title: _vm.$t("my_pendings.no_ownership"),
                          subtitle: _vm.$t("my_pendings.no_ownership_subtitle"),
                        },
                      })
                    : _c(
                        VCard,
                        [
                          _vm.typeSelected == 3
                            ? _c(VDataTable, {
                                staticClass: "table-inca",
                                style: { "font-size": "11px" },
                                attrs: {
                                  responsive: "",
                                  hover: "",
                                  items: _vm.lst_workbook,
                                  headers: _vm.tableauFieldsWorkBook,
                                  "sticky-header": true,
                                  search: _vm.filter.text_filter,
                                  page: _vm.pagination.current,
                                  "items-per-page": _vm.pagination.limit,
                                  "hide-default-footer": true,
                                },
                                on: {
                                  "update:page": function ($event) {
                                    return _vm.$set(
                                      _vm.pagination,
                                      "current",
                                      $event
                                    )
                                  },
                                  pagination: function ($event) {
                                    _vm.pagination.total = $event.itemsLength
                                  },
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "item.objectReference.object_name",
                                      fn: function (ref) {
                                        var item = ref.item
                                        return [
                                          _c(
                                            "div",
                                            { staticClass: "text-left" },
                                            [
                                              _c(
                                                "b",
                                                { staticClass: "table-name" },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      item.objectReference
                                                        .object_name
                                                    )
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "a",
                                                {
                                                  staticClass: "compose-name",
                                                  attrs: { title: item.id },
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      item.objectReference
                                                        .path_name
                                                    ) +
                                                      ":" +
                                                      _vm._s(
                                                        item.objectReference
                                                          .object_name
                                                      )
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      },
                                    },
                                    {
                                      key: "item.lastmodifiedtime",
                                      fn: function (ref) {
                                        var item = ref.item
                                        return [
                                          _c("a", [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("formatDate")(
                                                  item.lastModifiedTime
                                                )
                                              )
                                            ),
                                          ]),
                                        ]
                                      },
                                    },
                                    {
                                      key: "item.actions",
                                      fn: function (ref) {
                                        var item = ref.item
                                        return [
                                          _c(
                                            VBtn,
                                            {
                                              attrs: {
                                                rounded: "",
                                                small: "",
                                                dense: "",
                                                outlined: "",
                                                size: "sm",
                                                color: "secondary",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.onTableauWorkBookOwner(
                                                    item
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("btns.accept_reject")
                                                )
                                              ),
                                            ]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  2916672012
                                ),
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                ]
              : _vm._e(),
            _vm.typeSelected == 4
              ? [
                  _vm.lst_dataset.length == 0
                    ? _c("StateComponent", {
                        attrs: {
                          state: "empty_state",
                          title: _vm.$t("my_pendings.no_ownership"),
                          subtitle: _vm.$t("my_pendings.no_ownership_subtitle"),
                        },
                      })
                    : _c(
                        VCard,
                        [
                          _vm.typeSelected == 4
                            ? _c(VDataTable, {
                                staticClass: "table-inca",
                                style: { "font-size": "11px" },
                                attrs: {
                                  responsive: "",
                                  hover: "",
                                  items: _vm.lst_dataset,
                                  headers: _vm.powerbiFieldsDataset,
                                  "sticky-header": true,
                                  search: _vm.filter.text_filter,
                                  page: _vm.pagination.current,
                                  "items-per-page": _vm.pagination.limit,
                                  "hide-default-footer": true,
                                },
                                on: {
                                  "update:page": function ($event) {
                                    return _vm.$set(
                                      _vm.pagination,
                                      "current",
                                      $event
                                    )
                                  },
                                  pagination: function ($event) {
                                    _vm.pagination.total = $event.itemsLength
                                  },
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "item.objectReference.object_name",
                                      fn: function (ref) {
                                        var item = ref.item
                                        return [
                                          _c(
                                            "div",
                                            { staticClass: "text-left" },
                                            [
                                              _c(
                                                "b",
                                                { staticClass: "table-name" },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      item.objectReference
                                                        .object_name
                                                    )
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "a",
                                                {
                                                  staticClass: "compose-name",
                                                  attrs: { title: item.id },
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      item.objectReference
                                                        .path_name
                                                    ) +
                                                      ":" +
                                                      _vm._s(
                                                        item.objectReference
                                                          .object_name
                                                      )
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      },
                                    },
                                    {
                                      key: "item.lastmodifiedtime",
                                      fn: function (ref) {
                                        var item = ref.item
                                        return [
                                          _c("a", [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("formatDate")(
                                                  item.lastModifiedTime
                                                )
                                              )
                                            ),
                                          ]),
                                        ]
                                      },
                                    },
                                    {
                                      key: "item.actions",
                                      fn: function (ref) {
                                        var item = ref.item
                                        return [
                                          _c(
                                            VBtn,
                                            {
                                              attrs: {
                                                rounded: "",
                                                small: "",
                                                dense: "",
                                                outlined: "",
                                                size: "sm",
                                                color: "secondary",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.onPowerbiDatasetOwner(
                                                    item
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("btns.accept_reject")
                                                )
                                              ),
                                            ]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  886876520
                                ),
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                ]
              : _vm._e(),
            _vm.typeSelected == 5
              ? [
                  _vm.lst_report.length == 0
                    ? _c("StateComponent", {
                        attrs: {
                          state: "empty_state",
                          title: _vm.$t("my_pendings.no_ownership"),
                          subtitle: _vm.$t("my_pendings.no_ownership_subtitle"),
                        },
                      })
                    : _c(
                        VCard,
                        [
                          _vm.typeSelected == 5
                            ? _c(VDataTable, {
                                staticClass: "table-inca",
                                style: { "font-size": "11px" },
                                attrs: {
                                  responsive: "",
                                  hover: "",
                                  items: _vm.lst_report,
                                  headers: _vm.powerbiFieldsReport,
                                  "sticky-header": true,
                                  search: _vm.filter.text_filter,
                                  page: _vm.pagination.current,
                                  "items-per-page": _vm.pagination.limit,
                                  "hide-default-footer": true,
                                },
                                on: {
                                  "update:page": function ($event) {
                                    return _vm.$set(
                                      _vm.pagination,
                                      "current",
                                      $event
                                    )
                                  },
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "item.objectReference.object_name",
                                      fn: function (ref) {
                                        var item = ref.item
                                        return [
                                          _c(
                                            "div",
                                            { staticClass: "text-left" },
                                            [
                                              _c(
                                                "b",
                                                { staticClass: "table-name" },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      item.objectReference
                                                        .object_name
                                                    )
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "a",
                                                {
                                                  staticClass: "compose-name",
                                                  attrs: { title: item.id },
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      item.objectReference
                                                        .path_name
                                                    ) +
                                                      ":" +
                                                      _vm._s(
                                                        item.objectReference
                                                          .object_name
                                                      )
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      },
                                    },
                                    {
                                      key: "item.lastmodifiedtime",
                                      fn: function (ref) {
                                        var item = ref.item
                                        return [
                                          _c("a", [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("formatDate")(
                                                  item.lastModifiedTime
                                                )
                                              )
                                            ),
                                          ]),
                                        ]
                                      },
                                    },
                                    {
                                      key: "item.actions",
                                      fn: function (ref) {
                                        var item = ref.item
                                        return [
                                          _c(
                                            VBtn,
                                            {
                                              attrs: {
                                                rounded: "",
                                                small: "",
                                                dense: "",
                                                outlined: "",
                                                size: "sm",
                                                color: "secondary",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.onPowerbiReportOwner(
                                                    item
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("btns.accept_reject")
                                                )
                                              ),
                                            ]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  299150836
                                ),
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                ]
              : _vm._e(),
            _vm.typeSelected == 6
              ? [
                  _vm.lst_report_ds.length == 0
                    ? _c("StateComponent", {
                        attrs: {
                          state: "empty_state",
                          title: _vm.$t("my_pendings.no_ownership"),
                          subtitle: _vm.$t("my_pendings.no_ownership_subtitle"),
                        },
                      })
                    : _c(
                        VCard,
                        [
                          _vm.typeSelected == 6
                            ? _c(VDataTable, {
                                staticClass: "table-inca",
                                style: { "font-size": "11px" },
                                attrs: {
                                  responsive: "",
                                  hover: "",
                                  items: _vm.lst_report_ds,
                                  headers: _vm.datastudioFieldsReport,
                                  "sticky-header": true,
                                  search: _vm.filter.text_filter,
                                  page: _vm.pagination.current,
                                  "items-per-page": _vm.pagination.limit,
                                  "hide-default-footer": true,
                                },
                                on: {
                                  "update:page": function ($event) {
                                    return _vm.$set(
                                      _vm.pagination,
                                      "current",
                                      $event
                                    )
                                  },
                                  pagination: function ($event) {
                                    _vm.pagination.total = $event.itemsLength
                                  },
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "item.objectReference.object_name",
                                      fn: function (ref) {
                                        var item = ref.item
                                        return [
                                          _c(
                                            "div",
                                            { staticClass: "text-left" },
                                            [
                                              _c(
                                                "b",
                                                { staticClass: "table-name" },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      item.objectReference
                                                        .object_name
                                                    )
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      },
                                    },
                                    {
                                      key: "item.lastmodifiedtime",
                                      fn: function (ref) {
                                        var item = ref.item
                                        return [
                                          _c("a", [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("formatDate")(
                                                  item.lastModifiedTime
                                                )
                                              )
                                            ),
                                          ]),
                                        ]
                                      },
                                    },
                                    {
                                      key: "item.actions",
                                      fn: function (ref) {
                                        var item = ref.item
                                        return [
                                          _c(
                                            VBtn,
                                            {
                                              attrs: {
                                                size: "sm",
                                                color: "secondary",
                                                rounded: "",
                                                small: "",
                                                dense: "",
                                                outlined: "",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.onDatastudioReportOwner(
                                                    item
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("btns.accept_reject")
                                                )
                                              ),
                                            ]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  2427859144
                                ),
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                ]
              : _vm._e(),
            _vm.typeSelected == 7
              ? [
                  _vm.lst_datasource_ds.length == 0
                    ? _c("StateComponent", {
                        attrs: {
                          state: "empty_state",
                          title: _vm.$t("my_pendings.no_ownership"),
                          subtitle: _vm.$t("my_pendings.no_ownership_subtitle"),
                        },
                      })
                    : _c(
                        VCard,
                        [
                          _vm.typeSelected == 7
                            ? _c(VDataTable, {
                                staticClass: "table-inca",
                                style: { "font-size": "11px" },
                                attrs: {
                                  responsive: "",
                                  hover: "",
                                  items: _vm.lst_datasource_ds,
                                  headers: _vm.datastudioFieldsDatasource,
                                  "sticky-header": true,
                                  search: _vm.filter.text_filter,
                                  page: _vm.pagination.current,
                                  "items-per-page": _vm.pagination.limit,
                                  "hide-default-footer": true,
                                },
                                on: {
                                  "update:page": function ($event) {
                                    return _vm.$set(
                                      _vm.pagination,
                                      "current",
                                      $event
                                    )
                                  },
                                  pagination: function ($event) {
                                    _vm.pagination.total = $event.itemsLength
                                  },
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "item.objectReference.object_name",
                                      fn: function (ref) {
                                        var item = ref.item
                                        return [
                                          _c(
                                            "div",
                                            { staticClass: "text-left" },
                                            [
                                              _c(
                                                "b",
                                                { staticClass: "table-name" },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      item.objectReference
                                                        .object_name
                                                    )
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      },
                                    },
                                    {
                                      key: "item.lastmodifiedtime",
                                      fn: function (ref) {
                                        var item = ref.item
                                        return [
                                          _c("a", [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("formatDate")(
                                                  item.lastModifiedTime
                                                )
                                              )
                                            ),
                                          ]),
                                        ]
                                      },
                                    },
                                    {
                                      key: "item.actions",
                                      fn: function (ref) {
                                        var item = ref.item
                                        return [
                                          _c(
                                            VBtn,
                                            {
                                              attrs: {
                                                size: "sm",
                                                color: "secondary",
                                                rounded: "",
                                                small: "",
                                                dense: "",
                                                outlined: "",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.onDatastudioDatasourceOwner(
                                                    item
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("btns.accept_reject")
                                                )
                                              ),
                                            ]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  544200587
                                ),
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                ]
              : _vm._e(),
            _c("pagination-vue", { attrs: { pagination: _vm.pagination } }),
          ],
          2
        ),
        _vm.filter_enabled
          ? _c(
              "div",
              { staticClass: "col-md-3 d-none d-md-block pl-0" },
              [
                _c(
                  VCard,
                  { staticClass: "filters-inca" },
                  [
                    _c(
                      VCardTitle,
                      {
                        staticClass: "pointer",
                        on: {
                          click: function ($event) {
                            _vm.collapse_filter = !_vm.collapse_filter
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("my_pendings.search_filters")))]
                    ),
                    _c(
                      VCardText,
                      { staticClass: "pa-2 pt-0" },
                      [
                        _c(
                          VRow,
                          { attrs: { dense: "" } },
                          [
                            _c(
                              VCol,
                              { attrs: { cols: "12" } },
                              [
                                _c(VSelect, {
                                  attrs: {
                                    label: _vm.$t("my_pendings.object_type"),
                                    outlined: "",
                                    dense: "",
                                    items: _vm.object_types,
                                  },
                                  on: {
                                    change: function ($event) {
                                      return _vm.onChangeType()
                                    },
                                  },
                                  model: {
                                    value: _vm.typeSelected,
                                    callback: function ($$v) {
                                      _vm.typeSelected = $$v
                                    },
                                    expression: "typeSelected",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              VCol,
                              { attrs: { cols: "12" } },
                              [
                                _c(VTextField, {
                                  attrs: {
                                    label: _vm.$t("my_pendings.text_filter"),
                                    placeholder: _vm.$t(
                                      "my_pendings.text_filter"
                                    ),
                                    type: "text",
                                    outlined: "",
                                    dense: "",
                                  },
                                  on: {
                                    keyup: function ($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "enter",
                                          13,
                                          $event.key,
                                          "Enter"
                                        )
                                      ) {
                                        return null
                                      }
                                      return _vm.onSearch($event)
                                    },
                                  },
                                  model: {
                                    value: _vm.text_filter,
                                    callback: function ($$v) {
                                      _vm.text_filter = $$v
                                    },
                                    expression: "text_filter",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              VCol,
                              {
                                staticClass: "text-right",
                                attrs: { cols: "12" },
                              },
                              [
                                _c(
                                  VBtn,
                                  {
                                    staticClass: "default mr-1",
                                    attrs: { outlined: "" },
                                    on: { click: _vm.onLimpiar },
                                  },
                                  [_vm._v(_vm._s(_vm.$t("btns.clean")))]
                                ),
                                _c(
                                  VBtn,
                                  {
                                    staticClass: "primary",
                                    on: { click: _vm.onSearch },
                                  },
                                  [_vm._v(_vm._s(_vm.$t("btns.search")))]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            )
          : _vm._e(),
      ]),
      _c(
        "dialogs-component",
        {
          ref: _vm.MODAL_NAME_METADATA,
          attrs: {
            title:
              _vm.$t("btns.accept_reject") +
              " " +
              _vm.$t("my_pendings.ownership_modal"),
            width: 1200,
          },
        },
        [
          _c(
            "template",
            { slot: "body" },
            [
              _c("form-metadata-table-component", {
                ref: "metadataTableRef",
                attrs: {
                  "tpl-to-work": _vm.tplToUpdate,
                  "is-change-request": _vm.TYPE_CHANGE_METADA.PREVIEW_OWNER,
                },
                on: {
                  submit: _vm.saveTags,
                  refuse: _vm.refuseOwner,
                  cancel: function ($event) {
                    return _vm.$refs[_vm.MODAL_NAME_METADATA].onClose()
                  },
                },
              }),
            ],
            1
          ),
          _c(
            "template",
            { slot: "btnsLeft" },
            [
              _c(
                VBtn,
                {
                  attrs: { color: "secondary", outlined: "" },
                  on: {
                    click: function ($event) {
                      return _vm.$refs.metadataTableRef.clickDownloadCSV()
                    },
                  },
                },
                [
                  _c(VIcon, { attrs: { small: "" } }, [
                    _vm._v("icon-download"),
                  ]),
                  _vm._v(_vm._s(_vm.$t("btns.download_metadata"))),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "template",
            { slot: "btnsRight" },
            [
              _c(
                VBtn,
                {
                  attrs: { color: "secondary" },
                  on: {
                    click: function ($event) {
                      return _vm.$refs.metadataTableRef.validateForm(
                        "refuse",
                        $event
                      )
                    },
                  },
                },
                [
                  _c(VIcon, { attrs: { small: "" } }, [
                    _vm._v("icon-remove"),
                  ]),
                  _vm._v(_vm._s(_vm.$t("btns.reject"))),
                ],
                1
              ),
              _c(
                VBtn,
                {
                  attrs: { color: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.$refs.metadataTableRef.validateForm(
                        "ok",
                        $event
                      )
                    },
                  },
                },
                [
                  _c(VIcon, { attrs: { small: "" } }, [
                    _vm._v("mdi-check-circle-outline"),
                  ]),
                  _vm._v(_vm._s(_vm.$t("btns.accept"))),
                ],
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
      _c(
        "dialogs-component",
        {
          ref: "modalPendientTableauDataSource",
          attrs: {
            title:
              _vm.$t("btns.accept_reject") +
              " " +
              _vm.$t("my_pendings.ownership_modal"),
            width: 1200,
          },
        },
        [
          _c(
            "template",
            { slot: "body" },
            [
              _c("form-meta-datasource", {
                ref: "modalPendientTableauDataSource_body",
                attrs: {
                  item: _vm.data_ds,
                  isChangeRequest: "APPROVE_OWNER",
                  readonly: true,
                },
                on: { onCloseModal: _vm.onCloseModalDataSource },
              }),
            ],
            1
          ),
          _c(
            "template",
            { slot: "btnsRight" },
            [
              _c(
                VBtn,
                {
                  attrs: { outlined: "", color: "secondary" },
                  on: {
                    click: function ($event) {
                      return _vm.$refs[
                        "modalPendientTableauDataSource_body"
                      ].onReject()
                    },
                  },
                },
                [
                  _c(VIcon, { staticClass: "md-16" }, [
                    _vm._v("icon-remove"),
                  ]),
                  _vm._v(_vm._s(_vm.$t("btns.reject"))),
                ],
                1
              ),
              _c(
                VBtn,
                {
                  staticClass: "ml-2",
                  attrs: { id: "popover-target-1", color: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.$refs[
                        "modalPendientTableauDataSource_body"
                      ].onSave()
                    },
                  },
                },
                [
                  _c(VIcon, { staticClass: "md-16", attrs: { small: "" } }, [
                    _vm._v("mdi-check-circle-outline"),
                  ]),
                  _vm._v(_vm._s(_vm.$t("btns.accept"))),
                ],
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
      _c(
        "dialogs-component",
        {
          ref: "modalPendientTableauWorkBook",
          attrs: {
            title:
              _vm.$t("btns.accept_reject") +
              " " +
              _vm.$t("my_pendings.ownership_modal"),
            width: 1200,
          },
        },
        [
          _c(
            "template",
            { slot: "body" },
            [
              _c("form-meta-dashboard", {
                ref: "modalPendientTableauWorkBook_body",
                attrs: {
                  item: _vm.data_wb,
                  isChangeRequest: "APPROVE_OWNER",
                  readonly: true,
                },
                on: { onCloseModal: _vm.onCloModalWorkBook },
              }),
            ],
            1
          ),
          _c(
            "template",
            { slot: "btnsRight" },
            [
              _c(
                VBtn,
                {
                  attrs: { outlined: "", color: "secondary" },
                  on: {
                    click: function ($event) {
                      return _vm.$refs[
                        "modalPendientTableauWorkBook_body"
                      ].onReject()
                    },
                  },
                },
                [
                  _c(VIcon, { staticClass: "md-16", attrs: { small: "" } }, [
                    _vm._v("icon-remove"),
                  ]),
                  _vm._v(_vm._s(_vm.$t("btns.reject"))),
                ],
                1
              ),
              _c(
                VBtn,
                {
                  staticClass: "ml-2",
                  attrs: { color: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.$refs[
                        "modalPendientTableauWorkBook_body"
                      ].onSave()
                    },
                  },
                },
                [
                  _c(VIcon, { staticClass: "md-16", attrs: { small: "" } }, [
                    _vm._v("mdi-check-circle-outline"),
                  ]),
                  _vm._v(_vm._s(_vm.$t("btns.accept"))),
                ],
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
      _c(
        "dialogs-component",
        {
          ref: "modalPendientPowerbiDataset",
          attrs: {
            title:
              _vm.$t("btns.accept_reject") +
              " " +
              _vm.$t("my_pendings.ownership_modal"),
            width: 1200,
          },
        },
        [
          _c(
            "template",
            { slot: "body" },
            [
              _c("form-meta-dataset", {
                ref: "modalPendientPowerbiDataset_body",
                attrs: {
                  item: _vm.data_dset,
                  dataset_id: _vm.data_dset ? _vm.data_dset["dataset_id"] : "",
                  isChangeRequest: "APPROVE_OWNER",
                  readonly: true,
                },
                on: { onCloseModal: _vm.onCloModalDataset },
              }),
            ],
            1
          ),
          _c(
            "template",
            { slot: "btnsRight" },
            [
              _c(
                VBtn,
                {
                  attrs: { outlined: "", color: "secondary" },
                  on: {
                    click: function ($event) {
                      return _vm.$refs[
                        "modalPendientPowerbiDataset_body"
                      ].onReject()
                    },
                  },
                },
                [
                  _c(VIcon, { staticClass: "md-16", attrs: { small: "" } }, [
                    _vm._v("icon-remove"),
                  ]),
                  _vm._v(_vm._s(_vm.$t("btns.reject"))),
                ],
                1
              ),
              _c(
                VBtn,
                {
                  attrs: { id: "popover-target-1", color: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.$refs[
                        "modalPendientPowerbiDataset_body"
                      ].onSave()
                    },
                  },
                },
                [
                  _c(VIcon, { staticClass: "md-16", attrs: { small: "" } }, [
                    _vm._v("mdi-check-circle-outline"),
                  ]),
                  _vm._v(_vm._s(_vm.$t("btns.accept"))),
                ],
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
      _c(
        "dialogs-component",
        {
          ref: "modalPendientPowerbiReport",
          attrs: {
            title:
              _vm.$t("btns.accept_reject") +
              " " +
              _vm.$t("my_pendings.ownership_modal"),
            width: 1200,
          },
        },
        [
          _c(
            "template",
            { slot: "body" },
            [
              _c("form-meta-report", {
                ref: "modalPendientPowerbiReport_body",
                attrs: {
                  item: _vm.data_report,
                  report_id: _vm.data_report
                    ? _vm.data_report["report_id"]
                    : "",
                  isChangeRequest: "APPROVE_OWNER",
                  readonly: true,
                },
                on: { onCloseModal: _vm.onCloModalReport },
              }),
            ],
            1
          ),
          _c(
            "template",
            { slot: "btnsRight" },
            [
              _c(
                VBtn,
                {
                  attrs: { outlined: "", color: "secondary" },
                  on: {
                    click: function ($event) {
                      return _vm.$refs[
                        "modalPendientPowerbiReport_body"
                      ].onReject()
                    },
                  },
                },
                [
                  _c(VIcon, { staticClass: "md-16", attrs: { small: "" } }, [
                    _vm._v("icon-remove"),
                  ]),
                  _vm._v(_vm._s(_vm.$t("btns.reject"))),
                ],
                1
              ),
              _c(
                VBtn,
                {
                  attrs: { color: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.$refs[
                        "modalPendientPowerbiReport_body"
                      ].onSave()
                    },
                  },
                },
                [
                  _c(VIcon, { staticClass: "md-16", attrs: { small: "" } }, [
                    _vm._v("mdi-check-circle-outline"),
                  ]),
                  _vm._v(_vm._s(_vm.$t("btns.accept"))),
                ],
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
      _c(
        "dialogs-component",
        {
          ref: "modalPendientDatastudioReport",
          attrs: {
            title:
              _vm.$t("btns.accept_reject") +
              " " +
              _vm.$t("my_pendings.ownership_modal"),
            width: 1200,
          },
        },
        [
          _c(
            "template",
            { slot: "body" },
            [
              _c("form-meta-report-datastudio", {
                ref: "modalPendientDatastudioReport_body",
                attrs: {
                  item: _vm.data_report,
                  report_id: _vm.data_report
                    ? _vm.data_report["report_id"]
                    : "",
                  isChangeRequest: "APPROVE_OWNER",
                  readonly: true,
                },
                on: { onCloseModal: _vm.onCloModalReportDatastudio },
              }),
            ],
            1
          ),
          _c(
            "template",
            { slot: "btnsRight" },
            [
              _c(
                VBtn,
                {
                  attrs: { outlined: "", color: "secondary" },
                  on: {
                    click: function ($event) {
                      return _vm.$refs[
                        "modalPendientDatastudioReport_body"
                      ].onReject()
                    },
                  },
                },
                [
                  _c(VIcon, { staticClass: "md-16", attrs: { small: "" } }, [
                    _vm._v("icon-remove"),
                  ]),
                  _vm._v(_vm._s(_vm.$t("btns.reject"))),
                ],
                1
              ),
              _c(
                VBtn,
                {
                  attrs: { color: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.$refs[
                        "modalPendientDatastudioReport_body"
                      ].onSave()
                    },
                  },
                },
                [
                  _c(VIcon, { staticClass: "md-16", attrs: { small: "" } }, [
                    _vm._v("mdi-check-circle-outline"),
                  ]),
                  _vm._v(_vm._s(_vm.$t("btns.accept"))),
                ],
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
      _c(
        "dialogs-component",
        {
          ref: "modalPendientDatastudioDatasource",
          attrs: {
            title:
              _vm.$t("btns.accept_reject") +
              " " +
              _vm.$t("my_pendings.ownership_modal"),
            width: 1200,
          },
        },
        [
          _c(
            "template",
            { slot: "body" },
            [
              _c("form-meta-datasource-datastudio", {
                ref: "modalPendientDatastudioDatasource_body",
                attrs: {
                  item: _vm.data_datasource_ds,
                  dataset_id: _vm.data_datasource_ds
                    ? _vm.data_datasource_ds["dataset_id"]
                    : "",
                  isChangeRequest: "APPROVE_OWNER",
                  readonly: true,
                },
                on: { onCloseModal: _vm.onCloModalDatasourceDatastudio },
              }),
            ],
            1
          ),
          _c(
            "template",
            { slot: "btnsRight" },
            [
              _c(
                VBtn,
                {
                  attrs: { outlined: "", color: "secondary" },
                  on: {
                    click: function ($event) {
                      return _vm.$refs[
                        "modalPendientDatastudioDatasource_body"
                      ].onReject()
                    },
                  },
                },
                [
                  _c(VIcon, { staticClass: "md-16", attrs: { small: "" } }, [
                    _vm._v("icon-remove"),
                  ]),
                  _vm._v(_vm._s(_vm.$t("btns.reject"))),
                ],
                1
              ),
              _c(
                VBtn,
                {
                  attrs: { id: "popover-target-1", color: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.$refs[
                        "modalPendientDatastudioDatasource_body"
                      ].onSave()
                    },
                  },
                },
                [
                  _c(VIcon, { staticClass: "md-16", attrs: { small: "" } }, [
                    _vm._v("mdi-check-circle-outline"),
                  ]),
                  _vm._v(_vm._s(_vm.$t("btns.accept"))),
                ],
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }